module.exports = __webpack_public_path__ + "img/bt.85a0302e.gif";